(function() {
	'use strict';

	angular.module('quantixApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider','$ocLazyLoadProvider' ];

	function stateConfig($stateProvider,$ocLazyLoadProvider) {
		
		$ocLazyLoadProvider
		.config({
			'debug' : false, /*
								 * for debugging ocLazyLoad module
								 * 'true/false'
								 */
			'events' : true, /*
								 * for event ocLazyLoad module
								 * 'true/false'
								 */
			'modules' : [ {
				name : 'portfolioModule', /*
									 * injecting 
									 * Module for ocLazyLoad
									 */
				/* files for lazy load */
				files : ['app/portfolio/comparePortfolioDir.controller.js',
						'app/portfolio/comparePortfolios.controller.js',
						'app/portfolio/createPortfolio.controller.js',
						'app/portfolio/axisBankPortfolio.controller.js',
						'app/portfolio/editPortfolio.controller.js',
						'app/portfolio/portfolioDashboard.controller.js',
						'app/portfolio/portfolioNewsMore.controller.js',
						'app/portfolio/portfolioLanding.controller.js'
						]
			},
			{
				name : 'portfolioFinancials',
				files : [
					'app/portfolio/financialDetails.controller.js'
				]
			},
			{
				name : 'portfolioScores',
				files : [
					'app/portfolio/scoreDetails.controller.js'
				]
			}
		]
		});
		
		
		$stateProvider.state('portfolioDashboard', {
			parent : 'app',
			url : '/portfolioDashboard',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/portfolioDashboard.html',
					controller : 'PortfolioDashboardController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				loadMyCtrl : [
						'$ocLazyLoad',
						function($ocLazyLoad) {
							return $ocLazyLoad
									.load('portfolioModule'); /*
														 * Resolve
														 * promise
														 * and
														 * load
														 * before
														 * view
														 */
						} ]
			}
		}).state('comparePortfolios', {
			parent : 'app',
			url : '/comparePortfolios',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/comparePortfolios.html',
					controller : 'ComparePortfoliosController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				loadMyCtrl : [
						'$ocLazyLoad',
						function($ocLazyLoad) {
							return $ocLazyLoad
									.load('portfolioModule'); /*
														 * Resolve
														 * promise
														 * and
														 * load
														 * before
														 * view
														 */
						} ]
			}
		}).state('getAllPortfolios', {
			parent : 'app',
			url : '/getAllPortfolios',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/portfolioDashboard.html',
					controller : 'PortfolioDashboardController',
					controllerAs : 'vm'
				}
			}
		}).state('createPortfolio', {
			parent : 'portfolioDashboard',
			url : '/createPortfolio',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/createPortfolio.html',
					controller : 'CreatePortfolioController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				loadMyCtrl : [
						'$ocLazyLoad',
						function($ocLazyLoad) {
							return $ocLazyLoad
									.load('portfolioModule'); /*
														 * Resolve
														 * promise
														 * and
														 * load
														 * before
														 * view
														 */
						} ]
			}
		}).state('axisBankPortfolio', {
			parent : 'portfolioDashboard',
			url : '/axisBankPortfolio',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/axisBankPortfolio.html',
					controller : 'AxisBankPortfolioController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				loadMyCtrl : [
						'$ocLazyLoad',
						function($ocLazyLoad) {
							return $ocLazyLoad
									.load('portfolioModule'); /*
														 * Resolve
														 * promise
														 * and
														 * load
														 * before
														 * view
														 */
						} ]
			}
		})

		.state('userupdatedata', {
			parent : 'app',
			url : '/userupdatedata',
			params : {
				portfolioId : null,
				portfolioName : null,
				portfolioType:null,
				portfolioDateTime:null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/userupdatedata.html',
					controller : 'userupdatedata',
					controllerAs : 'vm'
				}
			}
		})
		.state('userBenchmarkData', {
			parent : 'app',
			url : '/userBenchmarkData',
			params : {
				portfolioId : null,
				portfolioName : null,
				portfolioType:null,
				portfolioDateTime:null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/userBenchmarkData.html',
					controller : 'userBenchmarkData',
					controllerAs : 'vm'
				}
			}
		})
		.state('editPortfolio', {
			parent : 'portfolioDashboard',
			url : '/editPortfolio',
			params : {
				portfolioId : null,
				isAllAlertSet :  null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/editPortfolio.html',
					controller : 'EditPortfolioController',
					controllerAs : 'vm'
				}
			}
		}).state('portfolioLanding', {
			parent : 'portfolioDashboard',
			url : '/portfolioLanding',
			params : {
				portfolioId : null,
				portfolioName:null,
				portfolioType:null,
				portfolioDateTime:null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/portfolioLanding.html',
					controller : 'PortfolioLandingController',
					controllerAs : 'vm'
				}
			}
		})
		.state('ratingdetails', {
			parent : 'app',
			url : '/ratingdetails',
			params : {
				portfolioId : null,
				portfolioName : null,
				portfolioType:null,
				portfolioDateTime:null,
				asOnDate:null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/ratingdetails.html',
					controller : 'RatingDetailsController1',
					controllerAs : 'vm'
				}
			}
		})
		.state('portfolioNews', {
			parent : 'app',
			url : '/portfolioNews',
			params : {
				portfolioId : null,
				selectedPortName : null,
				portfolioDateTime : null,
				id:null,
				newsHeadline:null
			},
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/portfolio/portfolioNewsMore.html',
					controller : 'PortfolioNewsController',
					controllerAs : 'vm'
				}
			}
		}).state('portfoliofinancials', {
			parent: 'app',
			url: '/portfoliofinancials',
			params: {
				portfolioId: null,
				portfolioName: null,
				portfolioType: null,
				portfolioDateTime: null,
				asOnDate: null
			},
			data: {
				authorities: []
			},
			views: {
				'content@': {
					templateUrl: 'app/portfolio/financialDetails.html',
					controller: 'FinancialDetailsController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				loadMyCtrl: [
					'$ocLazyLoad',
					function ($ocLazyLoad) {
						return $ocLazyLoad
							.load('portfolioFinancials');
					}]
			}
		}).state('portfolioScores', {
			parent: 'app',
			url: '/portfolioScores',
			params: {
				portfolioId: null,
				portfolioName: null,
				portfolioType: null,
				portfolioDateTime: null,
				asOnDate: null
			},
			data: {
				authorities: []
			},
			views: {
				'content@': {
					templateUrl: 'app/portfolio/scoreDetails.html',
					controller: 'ScoreDetailsController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				loadMyCtrl: [
					'$ocLazyLoad',
					function ($ocLazyLoad) {
						return $ocLazyLoad
							.load('portfolioScores');
					}]
			}
		})

	}
})();
